import React from 'react';
import { Query } from 'react-apollo';
import { theme } from '../../../Theming/Theming';
import homeCategoriesQuery from './HomeCategoriesQuery.gql';

//ARRAY MENUCATEGORIES WITH NO SUBMENU (ID)
const noSubMenu = [parseInt(theme.config.routes.blog.id, 10)];

const cleanCategories = categories => {
  let list = [];
  categories.forEach(category => {
    let item = { ...category };
    if (noSubMenu.includes(category.id)) {
      item.hasSubcategories = false;
      item.subcategories = [];
    }
    list.push(item);
  });
  return list;
};

const CategoryProvider = ({ children }) => (
  <Query variables={{ levels: 1 }} query={homeCategoriesQuery}>
    {result => {
      const { data } = result;
      const categories = (data && data.categories) || [];
      const categoryTreeRoots = cleanCategories(categories);
      return children({ categoryTreeRoots, categories });
    }}
  </Query>
);

export default CategoryProvider;
